<template>
  <div id="user-profile">
    <UserNav />
    <router-view />
  </div>
</template>

<script>
import UserNav from '@/components/UserNav.vue'

export default {
  name: 'UserProfilePage',
  components: { UserNav }
}
</script>
<style scoped>
</style>